import React, { useEffect, useState } from "react";
import { Input, Switch } from "antd";
import { FaSearch } from "react-icons/fa";
import axios from "axios";
import SwipeableViews from "react-swipeable-views";
import TradesTable from "../Component/TradesTable";
import { toast } from "react-toastify";
import SubscriptionTrans from "../Component/SubscriptionTrac";
import ViewfilterApiBot from "../Component/ViewfilterApiBot";
import LogsTable from "../Component/LogsTable";


const Search = () => {
  const [username, setUsername] = useState("");
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const container = document.getElementById("scrollContainer");
    if (container) {
      container.style.scrollBehavior = "smooth";
    }
  }, []);

  const handleChangeIndex = (newIndex) => {
    setIndex(newIndex);
  };

  const [wallet, setwallet] = useState([]);
  const [analytics1, setAnalytics1] = useState("");
  const [userListPack, setUserListPack] = useState([]);
  const [showViewMore, setShowViewMore] = useState(false);
  const [userDetails, setUserDetails] = useState("");
  const [userCondition, setUserCondition] = useState("");
  const jwt = localStorage.getItem("jwt");

  const handleSubmit = (e) => {
    e.preventDefault();

    setwallet([]);
    setAnalytics1("");
    setUserListPack([]);
    setUserDetails("");
    setUserCondition("");
    setShowViewMore(false);

    const postData = {
      jwt: jwt,
      username: username?.toLowerCase(),
    };

    const response = axios({
      method: "POST",
      headers: { "Content-Type": "application/json" },
      url: process.env.REACT_APP_API_PATH_USER + "user_available",
      data: postData,
    })
      .then((response) => {
        {
          if (response?.data?.Success === `User ${username} does not exists!`) {
            toast.error(response?.data?.Success);
          } else {
            toast.success(response?.data?.Success);
          }
        }
        getUserDetails();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.Error);
      });
  };

  const getUserDetails = () => {
    const postData = { jwt: jwt, username: username?.toLowerCase() };
    axios({
      method: "POST",
      headers: {
        Authorization: `Bearer ${jwt}`,
        "Content-Type": "application/json",
      },
      url: process.env.REACT_APP_API + "/user/user_details",
      data: postData,
    })
      .then(async function (response) {
        setUserDetails(response?.data?.Success);

      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.Error) {
          toast.error(err.response.data.Error);
        } else {
          console.log("An unknown error occurred.");
        }
        setUserDetails("");
      });
  };

  const handleToggle = (checked) => {
    const postData = {
      jwt: jwt,
      username: userDetails?.Username,
      status: checked,
    };

    axios({
      method: "POST",
      headers: {

        "Content-Type": "application/json",
      },
      url: process.env.REACT_APP_API + "/bot/enable_custom_bot",
      data: postData,
    })
      .then((response) => {
        if (response.status === 200) {
          toast.success(response?.data?.Success);
          getUserDetails();
        }
        toast.success(response?.data?.Success);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.Error);
      });
  };

  const tabs = ["PACKAGE", "API/BOT", "TRADES", "SIGNAL"];

  const Loginast = (username) => {
    const postdata = {
      username: username?.toLowerCase(),
    };
    const response = axios({
      method: 'POST',
      headers: {
        'accept': 'application/json'
      },
      url: process.env.REACT_APP_API_ENT + "/user/entry",
      data: postdata
    }).then(res => {
      if (res?.status === 200) {
        window.open(`https://logintrade.pivixa.com/?jwt=${res?.data?.JWT}`, '_blank');
        toast(res?.data?.Success)
      }
    })
      .catch(err => {
        toast.error(err?.res?.data?.Error)
      });
  };


  return (
    <>
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-3  gap-4 p-4">

          {/* Search Form */}
          <div>
            <form className="flex items-center gap-4" onSubmit={handleSubmit}>
              <Input
                type="text"
                placeholder="Search Username..."
                className="lowercase focus:border-colorAccent hover:border-colorAccent bg-colorGreyish placeholder:text-gray-500 rounded-xl py-3 px-4 text-sm w-full md:w-80"
                value={username}
                onChange={(e) => setUsername(e.target.value.trim().toLowerCase())}
              />
              <button
                type="submit"
                className="bg-black py-3 px-4 text-white rounded-xl text-2xl flex items-center justify-center"
              >
                <FaSearch />
              </button>
            </form>

            {userDetails && (
              <div className="mt-4 rounded-xl overflow-hidden bg-white shadow-md w-full md:w-96">
                <div className="p-4">
                  <p className="mt-2 text-gray-800 flex justify-between items-center">
                    <span>Name:</span>
                    <span className="font-semibold">{userDetails?.Name}</span>
                  </p>
                  <p className="mt-2 text-gray-800 flex justify-between items-center">
                    <span>Sponsor:</span>
                    <span className="font-semibold">{userDetails?.Sponsor}</span>
                  </p>
                  <div className="flex items-center gap-4 mt-4">
                    <span className="text-sm font-medium">Create Custom Bot:</span>
                    <Switch
                      checked={userDetails?.Bot_Features?.Create_Custom_Bot}
                      onChange={handleToggle}
                      className="custom-switch"
                    />
                  </div>
                </div>
              </div>
            )}

          </div>

          {/* User Details Section */}


          {/* Tabs Section */}


          <div className="col-span-2">
            {userDetails && (
              <div className="mt-6 w-full">
                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
                  {tabs.map((tab, tabIndex) => (
                    <div
                      key={tabIndex}
                      className={`py-3 px-6 text-sm font-medium text-center cursor-pointer rounded-xl transition-all duration-200 ${index === tabIndex
                          ? "bg-colorAccent text-white shadow-md rounded-2xl"
                          : "bg-white text-gray-800 hover:bg-gray-100"
                        }`}
                      onClick={() => handleChangeIndex(tabIndex)}
                    >
                      {tab}
                    </div>
                  ))}
                </div>
              </div>
            )}
            {userDetails && (
              <div className="mt-8">
                <SwipeableViews
                  index={index}
                  onChangeIndex={handleChangeIndex}
                  className="mx-4"
                >
                  <div>
                    <SubscriptionTrans userName={userDetails?.Username} />
                  </div>

                  <div>
                    <ViewfilterApiBot userDetails={userDetails} userName={userDetails?.Username} />
                  </div>

                  <div>
                    <TradesTable username={userDetails?.Username} />
                  </div>

                  <div>
                    <LogsTable userName={userDetails?.Username} />
                  </div>
                </SwipeableViews>
              </div>
            )}
          </div>

        </div>

        {/* Tab Content */}


        {/* No user details message */}
        {!userDetails && (
          <div className="h-96 flex justify-center items-center">
            <h1 className="text-bold bg-colorSecondaryDark animate-pulse text-white p-4 rounded-lg text-3xl">
              Kindly Enter Username
            </h1>
          </div>
        )}
      </div>
    </>

  );
};

export default Search;
